import React from 'react';
import { Switch, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './components/Home/Home';
import Bio from './components/Bio/Bio';
import Workshops from './components/Workshops/Workshops';
import Scripts from './components/Scripts/Scripts';
import Screenwriting from './components/Screenwriting/Screenwriting';
import Consulting from './components/Consulting/Consulting';
import Music from './components/Music/Music';
import Recommendations from './components/Recommendations/Recommendations';
import Newsletter from './components/Newsletter/Newsletter';
import Submissions from './components/Submissions/Submissions';
import Press from './components/Press/Press';
import Store from './components/Store/Store';
import Contact from './components/Contact/Contact';
import Navigation from './components/Navigation/Navigation';
import TerryPorter from './components/TerryPorter/TerryPorter';
 
function App() {
  return (
    <>
    <Navigation/>
    <Header/>
<div className="wrapper"> 
{/* <Redirect from="/*" to="/"><Home /></Redirect> */}
    <Switch>
      <Route exact path="/"><Home /></Route>
      <Route path="/Bio"><Bio /></Route>
      <Route path="/Workshops"><Workshops /></Route>
      <Route path="/Scripts"><Scripts /></Route>
      <Route path="/Screenwriting"><Screenwriting /></Route>
      <Route path="/Consulting"><Consulting /></Route>
      <Route path="/Music"><Music /></Route>
      <Route path="/Recommendations"><Recommendations /></Route>
      <Route path="/Newsletter"><Newsletter /></Route>
      <Route path="/Submissions"><Submissions /></Route>
      <Route path="/Press"><Press /></Route>
      <Route path="/Store"><Store /></Route>
      <Route path="/Contact"><Contact /></Route>
      <Route path="/TerryPorter"><TerryPorter /></Route>
      {/* Redirect any path that doesn't match the above routes to the home page: */}
      <Route path="*"><Home /></Route>
    </Switch>
  <Footer/>
</div>
</>
  );
}

export default App;
